import script from "./header-web.vue?vue&type=script&setup=true&lang=js"
export * from "./header-web.vue?vue&type=script&setup=true&lang=js"

import "./header-web.vue?vue&type=style&index=0&id=0e35dd85&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e35dd85"]])

export default __exports__